import { ROUTES } from "../constants/routes";

/**
 * Whether it is worth firing the (third-party) IP geolocation request for the
 * given location.
 *
 * The result is guaranteed to be discarded - so the request should not be
 * sent at all - in three cases: the URL hash already supplies a center, the
 * pathname is a campground deep link (its own view state wins), or the
 * pathname is under the admin console (which never renders a map). Firing a
 * geolocation request whose result cannot possibly be used is waste with a
 * privacy dimension, so both call sites (App.tsx's module-scope kickoff and
 * CampgroundMap's own effect) share this one predicate instead of keeping
 * separate, driftable copies.
 */
export const shouldGeolocate = (pathname: string, hash: string): boolean => {
  const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
  const hasHashCenter = hashParams.get("lat") || hashParams.get("lng");
  if (hasHashCenter) return false;

  if (pathname.includes(ROUTES.CAMPGROUND)) return false;
  if (pathname.startsWith(ROUTES.RANGER_STATION)) return false;

  return true;
};
